var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"review-hearing-test"},[_c('h1',[_vm._v("다비치 히어링")]),_c('p',[_vm._v("다비치 히어링을 소개합니다.")])])}]

export { render, staticRenderFns }